export default __webpack_public_path__ + "static/media/restaurant_2.c5a53b3a.jpg";